export default function (totalCharge, quantity, transactionId) {
  gtag("event", "conversion", {
    send_to: "AW-17960072554/KeQRCP7WnZMcEOrqg_RC",
    value: totalCharge,
  });

  fbq("track", "Purchase", {
    value: totalCharge,
    currency: "USD",
    content_ids: [transactionId],
    content_type: "product",
  }, {
    eventID: transactionId,
  });
}
